import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import UnlockButton from './UnlockButton';
import { useLanguage } from '../context/LanguageContext';

export default function ReadingDisplay({ reading, loading, isUnlocked, onUnlock, onRetry }) {
  const { t } = useLanguage();

  if (loading) {
    return (
      <div className="reading-loading">
        <p>{t('readingLoading')}</p>
      </div>
    );
  }

  // AI request failed
  if (reading === '__FAILED__') {
    return (
      <div className="reading-card reading-error">
        <p className="reading-error-msg">{t('failed')}</p>
        {onRetry && (
          <button className="retry-button" onClick={onRetry}>
            {t('retryText') || '重新解读'}
          </button>
        )}
      </div>
    );
  }

  if (!reading) {
    return (
      <div className="reading-empty muted">
        <p>{t('readingEmpty')}</p>
      </div>
    );
  }

  const lines = reading.split('\n');
  const previewCount = Math.min(30, Math.ceil(lines.length / 2));
  const visibleText = isUnlocked ? reading : lines.slice(0, previewCount).join('\n');
  const hiddenLinesCount = lines.length - (isUnlocked ? lines.length : previewCount);

  return (
    <div className="reading-card">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {visibleText}
      </ReactMarkdown>

      {!isUnlocked && hiddenLinesCount > 0 && (
        <div className="locked-overlay">
          <p>{t('lockedLines').replace('{count}', hiddenLinesCount)}</p>
          <UnlockButton onUnlock={onUnlock} />
        </div>
      )}
    </div>
  );
}
